import React,{useEffect,useState} from 'react'
import bgChannel from '../channelBackground.avif'
import {useParams} from 'react-router-dom';
import {fetchDetails} from './getDetails';
import Video from './video';
import {subscribeCount} from './getSubscriberCount';





function ChannelDetails(props) {
  const [channelVideos,setChannelVideos] = useState([]);
  const [channelDetails,setChannelDetails] = useState();
  const {channelId} = useParams();

  useEffect(()=>{
    const getChannelVideos = async()=>{
      const details1 = await fetchDetails(`search?part=snippet,id&channelId=${channelId}`);
      const details2 =  await fetchDetails(`channels?part=snippet,statistics&id=${channelId}`);
    

      setChannelVideos(details1.items);
      setChannelDetails(details2.items[0]);
      
    }
    getChannelVideos();
    props.HideToShow();


  },[channelId]);

  

  const bgColor = 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80';

  return (
    <div className='mt-14 '>
      {/* <img src="https://lh3.googleusercontent.com/N1VYCJENxSvkX5t4xAOE1PQa-P6E2kKrYlVAvN3bh-F6ZeYeN4Rmazp-fuguQtCO-hv4xR9dsA" class="w-full h-[12rem]"  alt="@joerogan"/> */}
      <img src={channelDetails?.brandingSettings?.image?.bannerExternalUrl}  alt={channelDetails?.snippet?.customUrl} className='w-full h-[10rem]'/>
      <div className='flex flex-col justify-between items-center  text-white mt-2 space-y-1'>
        <img src={channelDetails?.snippet?.thumbnails?.default?.url } className='border-2 border-red-500 rounded-full w-30'  alt={channelDetails?.snippet?.customUrl}/>
        <p className='text-sm font-medium'>{channelDetails?.snippet?.title}</p>
        <p className='text-sm font-medium'>{subscribeCount(channelDetails)} Subscribers</p>
      </div>
      {/* <div className="bg-channel" >

      </div> */}

      <div className="videos w-full flex px-10">
      <Video videos={channelVideos} className=""/>
      </div>
    </div>
  )
}

export default ChannelDetails